export const CVA_CONSTANTS = {
  DISABLE_NAVIGATION: ['/login', '/forgot-password', '/sign-up'],
  CONST: {
    SOAP_SETTINGS: 'SOAP_SETTINGS',
    USER_PREFERENCES: 'USER_PREFERENCES'
  },
  PERMISSION: {
    READ: 'read',
    WRITE: 'write',
    UPDATE: 'update',
    DELETE: 'delete'
  },
  MESSAGE: {
    invalid_credentials: 'You have entered invalid credentials, please try again.',
    ACCOUNT_EXPIRY_REMINDER: 'Your subscription will auto-renew in {count} day(s). Make sure your payment details are up to date to avoid any disruptions in your service.',
    ACCOUNT_EXPIRY_LAST_DAY_REMINDER: 'Your subscription will auto-renew today. Make sure your payment details are up to date to avoid any disruptions in your service.',
    ACCOUNT_EXPIRED: 'Your subscription renewal is required. Please visit the Plan & Billing section to complete the payment and continue enjoying our services.',
    FORGOT_PASSWORD_LINK_SENT: 'The password reset link has been sent to your email address.',
    FORGOT_PASSWORD_ERROR: 'Email does not found! Are you sure you are already a member?',
    CHANGE_PASSWORD_SUCCESS: 'Password updated successfully. Please login.',
    CHANGE_PASSWORD_ERROR: 'Error occurred while changing password.',
    PASSWORD_VALIDATION_MSG: 'Password must be atleast 8 characters, include an uppercase, lowercase and a special character.',
    TEXTAREA_PLACEHOLDER: " Hello Dr. \n Welcome to AI-Enhanced \n Online Consultation! \n\n Click on mic icon to proceed.",
    GENERATE_SOAP_NOTE_ERR: "There's a temporary problem with the service. If you continue to get this message, please contact support@intellitekhealth.com",
    NOT_MENTION: 'not provided',
    TRANSCRIPTION_UPDATED: 'Transcription updated successfully.',
    RECORD_UPDATED: 'Record updated successfully.',
    ERROR_WHILE_SAVING: 'Error while saving the data.',
    SESSION_SAVED_SUCCESSFULLY: 'Session saved successfully.',
    PREFERENCES_UPDATED_SUCCESSFULLY: 'Preferences updated successfully.',
    NO_RESPONSE_FOUND: "No response found.",
    UNABLE_TO_FETCH_RECORDS: 'Unable to fetch records.',
    UNAUTHORIZED: 'Unauthorized',
    CONFIRM_TO_CLEAN: 'Are you sure you want to delete the recorded transcription?',
    CONFIRM_FOR_NEW_SESSION: 'By starting a "New Session" current transcript and the generated notes associated with the transcript would be lost.',
    RECORDED_TRANSCRIPT_DELETED: 'Record transcript has been successfully removed.',
    CONFIRM_TO_CLEAR_UNSAVED_TRANSCRIPTION: 'Selecting this saved transcript will delete the recorded transcript. Are you sure you want to continue?',
    CONSULTATION_DISCLAIMER: 'By starting consultation you confirm having received approval from the patient to record the session.',
    CONFIRM_TO_DELETE_SESSION: 'Are you sure, you want to delete this transcript?',
    CONFIRM_TO_CLEAR_TRANSCRIPT: 'Are you sure, you want to clear the recorded transcript?',
    CONFIRM_TO_CANCEL_SUBSCRIPTION: 'Are you sure you want to cancel the current subscription?',
    SUBSCRIPTION_CANCELLED_SUCCESS: 'Current subscription successfully cancelled.',
    SUBSCRIPTION_CANCELLED_FAILED: 'Current subscription cancellation failed.',
    SUBSCRIPTION_CANCEL_PROGRESS: 'Subscription cancellation is in progress.',
    SUBSCRIPTION_RENEW_PROGRESS: 'Subscription reactivation in progress.',
    SUBSCRIPTION_RENEW_SUCCESS: 'Subscription successfully reactivated.',
    SUBSCRIPTION_RENEW_FAILED: 'Subscription reactivation failed.',
    CONTENT_COPIED: 'Copied to clipboard.',
    SESSION_DELETED: 'Transcript deleted successfully.',
    UNKNOWN_LOGIN_ERR: 'Error occurred while logging in.',
    GENERAL_MESSAGE_FOR_TEMPLATE: 'Please wait, we’re preparing your content...',
    GENERAL_MASSAGE_FOR_TEMPLATE_1: 'Just a moment, we’re almost finished!',
    NO_TEMPLATE_SELECTED: 'Please select a template from the list to generate notes.',
    GENERATING_REFERRAL_NOTE: "Generating referral note",
    CREATING_REFERRAL_NOTE: "Finalizing referral note",
    GENERATING_MEDICAL_CERTIFICATE: "Extracting medical insights OR Generating medical certificate",
    FINALIZING_MEDICAL_CERTIFICATE: "Finalizing medical certificate",
    GENERATING_REPORT: "Extracting procedure insights...",
    PREPARING_SURGICAL_DOCUMENT: "Preparing your Intra-Operative Procedures document...",
    FINALIZING_REPORT: "Finalizing your Intra-Operative Procedures. Almost there!",
    PREPARING_POST_OP: "Generating Post-Op Summary",
    FINALIZING_POST_OP: "Finalizing Post-Op Summary",
    TRANSFORMING_TRANSCRIPT: 'Analysing transcript...',
    EXTRACTING_INSIGHTS: 'Extracting medical insights...',
    CREATING_SOAP_NOTE: 'Finalizing SOAP Notes',
    ANALYZING_TRANSCRIPT: 'Analysing transcript...',
    GENERATING_ISSUE_LIST: 'Generating list of medical issues',
    SAVING_CONSULTATION_SESSION: 'Saving consultation transcript..',
    UPDATING_CONSULTATION_SESSION: 'Updating session details...',
    UPDATING_TRANSCRIPT_SESSION: 'Updating transcript...',
    DELETING_SESSION: 'Deleting the transcript...',
    SOAP_DESC: 'A structured way to document patient notes.',
    SOAP_LITE_DESC: 'Simplified patient encounter notes.',
    SOAP_CLASSIC_DESC: 'Comprehensive patient encounter notes.',
    ISSUE_LIST_DESC: 'A list of current issues for the patient.',
    ISSUE_LIST_LITE_DESC: "Summary breakdown of patient's issues.",
    ISSUE_LIST_CLASSIC_DESC: 'Comprehensive patient issue summary.',
    MEDICAL_CERTIFICATE_DESC: "A medical document verifying a patient's health condition.",
    REFERRAL_DESC: 'A letter request for specialist consultation or additional care services.',
    INTRA_OPERATIVE_PROCEDURES_DESC: 'A structured report documenting surgical procedure.',
    MAKE_MY_SELF_PROVIDER_CONFIRMATION: 'You will be logged out automatically after updating your role. Do you want to continue?',
    CARD_NUMBER_IS_REQUIRED: 'Card Number is required.',
    CARD_NUMBER_IS_NOT_VALID: 'Card Number is not valid.',
    CARD_CVV_IS_REQUIRED: 'CVC is required.',
    CARD_CVV_IS_NOT_VALID: 'CVC is not valid.',
    CARD_EXPIRY_IS_REQUIRED: 'Expiry is required.',
    CARD_EXPIRY_IS_NOT_VALID: 'Expiry is not valid.',
    ENABLE_PAYMENT_FORM: 'Initializing payment...',
    PAYMENT_IN_PROGRESS: 'Payment in progress...',
    PAYMENT_SUCCESSFUL: 'Payment successful.',
    SUBSCRIPTION_SUCCESSFUL: 'Subscription successful.',
    PAYMENT_FAILED: 'Payment failed.',
    PAYMENT_CANCELED: 'Payment canceled.',
    PAYMENT_ERROR: 'Error occurred while making payment.',
    NOTE_TEMPLATE: 'Note Template',
    PREFORMATTED_TEMPLATE: 'Preformatted Template',
    NO_PERMISSION: 'You do not have the necessary permissions to access this feature.',
    DEFAULT_NOTE_TEMPLATE: "Choose a template for your notes to ensure consistency.",
    DEFAULT_LETTER_TEMPLATE: "Choose a template for your letters to ensure consistency.",
    LANGUAGE: "Select the language for your transcripts and notes.",
    DATE_FORMAT: "Choose how dates will be displayed.",
    TRANSCRIPT_TIMER: "Select a timer type for tracking transcription duration.",
    SAVE_TRANSCRIPT: "Enable auto saving of your transcripts and notes.",
    GENERATE_NOTES: "Enable auto generation of your consultation notes.",
    RETENTION_PERIOD: "Set how long transcripts will be stored.",
    TOOLTIP_SAVE_TRANSCRIPT: "Automatically store your consultation transcripts and notes in our secure system. When disabled, transcripts and notes can be saved manually. Note: This setting affects future consultations only. ",
    TOOLTIP_GENERATE_NOTES: "Automatically generate consultation notes when recording stops. When disabled, notes can be generated manually. Note: This setting affects future consultations only. ",
    TOOLTIP_RETENTION_PERIOD: "Choose how long your transcripts are kept in the system before automatic deletion. This helps comply with data retention policies while maintaining access to your clinical documentation. Consider your local regulations when selecting a period. ",
    TOOLTIP_DEFAULT_NOTE_TEMPLATE: "Select a standardized format for your clinical notes. This template will be automatically applied to new consultations, helping maintain consistency across your documentation while still allowing for the use of other templates during each session after the inital default note is generated. ",
    TOOLTIP_DEFAULT_LETTER_TEMPLATE: "Select a standardized format for your letter. This template will be automatically applied to new letters, helping maintain consistency across your documentation while still allowing for the use of other templates during each session after the inital default note is generated. ",
    TOOLTIP_TRANSCRIPT_TIMER: "Choose how consultation duration is tracked and displayed. This helps monitor consultation length and can be useful for billing and practice management. You can select between countdown or stopwatch modes. ",
    TOOLTIP_LANGUAGE: "Set your preferred language for the CVA scribe interface and transcriptions. This affects both the system interface and the generated clinical notes. Make sure to select a language and region that matches your location. ",
    TOOLTIP_DATE_FORMAT: " Customize how dates appear in your clinical notes and throughout the system. This ensures consistency with your existing medical records and regional standards. Select a format that aligns with your practice's documentation guidelines. ",
    TOOLTIP_CCP: "Enable this option if you actively see patients and need to use the AI scribe during consultations. This will count toward your practice's provider licenses.",
    THANKS_FOR_FEEDBACK: "Thanks for the feedback.",
    INSUFFICIENT_ACCESS: "You do not have sufficient permissions to access this page. Please contact an administrator for assistance.",
    REVIEW_NOTE_DISCLAIMER: "Review your note to confirm it accurately captures the visit before using it.",
    SPEECH_START_DISCLAIMER: "By clicking Start Recording you have obtained verbal consent from the patient/their carer to use this AI tool.",
    SPEECH_RESUME_DISCLAIMER: "By clicking Resume Recording you have obtained verbal consent from the patient/their carer to use this AI tool.",
    USER_ALREADY_EXISTS: 'User already exists. Redirecting to login page.',
    OTP_SENT: 'An OTP has been sent to your email address.',
    DISABLED_SAVE_TRANSCRIPTION_TOOLTIP: "Need to save this conversation? Simply visit the 'Preferences' section and turn on the 'Save Transcription' option to store the conversation history for later reference.",
    TRIAL_ACCOUNT_CREATED: 'Your account has been registered. Please login.',
    EMAIL_VERIFICATION_CODE_ERROR: 'Could not send verification code to your email. Please try again later',
    INVALID_VERIFICATION_CODE_MSG: 'Verification code does not match. Please enter a valid verification code',
    LOADING_MANAGE_BILLING: "Please wait while we retrieve your billing information...",
    ERROR_MANAGE_BILLING: "Something went wrong while fetching your billing information. Please try again later.",
    SAVING_TEMPLATE: 'Saving your template...',
    UPDATING_TEMPLATE: 'Updating template details...',
    TEMPLATE_SAVED_SUCCESSFULLY: 'Template saved successfully.',
    TEMPLATE_UPDATED_SUCCESSFULLY: 'Template updated successfully.',
    CONFIRM_TO_DELETE_TEMPLATE: 'Are you sure, you want to delete this template?',
    DELETING_TEMPLATE: 'Deleting the template...',
    TEMPLATE_DELETED: 'Template deleted successfully.',
    UNABLE_TO_GENERATE: 'Unable to generate template.',
    CONFIRM_TO_MARK_TEMPLATE_FAV: 'Are you sure you want to add this template to your favorites?',
    CONFIRM_TO_UN_MARK_TEMPLATE_FAV: 'Are you sure you want to remove this template from your favorites?',
    UNABLE_TO_PROCESS: 'Unable to process the request.',
    ERROR_ON_GENERATING_PREVIEW: 'Unable to generate the preview.',
    LOADING_NOTE: "Loading up your note, template is on the way ...",
    TURNING_NOTE_INTO_TEMPLATE: "Turning your note into a template...",
    TURNING_FILE_INTO_TEMPLATE: "Turning your file into a template...",
    FILE_GETTING_READY: "Your file is getting ready to become a template!",
    GETTING_TEMPLATE_TO_WORK: "Getting your new template to work.",
    LOADING_PREVIEW: "Loading preview...",
    RENEW_SUBSCRIPTION_WITH_PAUSED_ACTIVE: "Your subscription is valid until {{EndDate}}. Renew now to continue enjoying access. Please re-login after a successful renewal. Proceed?",
    RENEW_SUBSCRIPTION_WITH_PAUSED_EXPIRE: "Your subscription has expired. Renewing will start a new cycle from today, based on your selected {{PlanInterval}} plan. Please re-login after a successful renewal. Proceed?",
    RENEW_FAILED_PAYMENT: 'You’ll be logged out and redirected to Stripe for payment. Please re-login after completing the payment.',
    CONSULTATION_TOUR_TITLE: 'Your Consultation Journey',
    CONSULTATION_TOUR_DESC: 'A step-by-step guide to making the most of your AI medical scribe.',
    TEMPLATE_TOUR_TITLE: 'Building Custom Templates',
    TEMPLATE_TOUR_DESC: 'A guide to building and customizing templates tailored to your needs.',
    UNABLE_TO_SAVE_TEMPLATE: 'Unable to save template',
    UNABLE_TO_UPDATE_TEMPLATE: 'Unable to update template',
    INACTIVE_ACCOUNT: 'Your account is currently inactive. Please contact support for assistance.'
  },
  REGEX: {
    // eslint-disable-next-line no-useless-escape
    specialCharacter: /[!@#\$%\^\&*\)\(+=._\-?]$/,
    ordinalDateRegex: /\d{1,2}(st|nd|rd|th)/i,
    patterns: [
      /\bpractitionerId\s*=\s*([^&]+)/,
      /\bappointmentId\s*=\s*([^&]+)/,
      /\bflt\s*=\s*([^&]+)/,
      /\btoken\s*=\s*([^&]+)/,
    ],
    titleInput: /^[a-zA-Z0-9 _&,\-.]*$/,
    patientName: /^[a-zA-Z0-9,.&\s-]*$/,
    // eslint-disable-next-line no-useless-escape
    passwordRegex: /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-[\]{};':"\\|,.<>\/?-])(?=.*[a-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-[\]{};':"\\|,.<>\/?-]{8,}$/,
    emailRegex: /^(?!\s)(?=.{1,255}$)([A-Za-z0-9._%+-]+)@([A-Za-z0-9.-]+\.[A-Za-z]{2,})$/
  },
  USER_SUBSCRIPTION_CONST: {
    initial: {
      title: 'Admin Login',
      subtitle: 'Enter your email to get started',
      submit: 'Submit'
    },
    login: {
      title: 'Welcome Back!',
      subtitle: 'Please enter your password to continue',
      submit: 'Login'
    },
    register: {
      title: 'Sign Up',
      subtitle: 'Complete the information below to get started.',
      submit: 'Register'
    },
    verify: {
      title: 'Verify Email',
      subtitle: 'Enter the six digit verification code we sent to your email address to verify your new account',
      submit: 'Verify & Continue'
    }
  },
  CURRENCY: { symbol: '$', value: 'USD' },
  EMAIL_MAX_LENGTH: 255
};

export enum USER_SUBSCRIPTION_ENUM {
  INITIAL = 'initial',
  LOGIN = 'login',
  REGISTER = 'register',
  CONTACT_INFO = 'contact_info',
  VERIFY_EMAIL = 'verify',
}
export interface Country {
  id: string;
  iso: string;
  name: string;
  code: string;
  flagImagePos: string;
}

export interface UserDetails {
  id?: string,
  email: string,
  firstName: string,
  lastName: string,
  providerId: string
  createdAt?: string,
  createdby?: string,
  isActive: number;
  modifiedby?: string;
  modifiedAt?: string;
  phoneNo?: string;
  tenantId?: string;
  subKey?: string;
  roles?: string[];
  company?: string
}

export enum MicrophoneErrorMessages {
  NotAllowedError = "Microphone access was denied. Please allow microphone access in your browser settings.",
  NotFoundError = "No microphone was found. Please make sure your microphone is connected and try again.",
  NotReadableError = "Your microphone is currently in use by another application. Please close other apps that might be using the microphone.",
  NotSupportedError = "Your browser does not support microphone access. Please use a supported browser like Chrome or Firefox.",
  SecurityError = "Microphone access is blocked due to security settings. Please access the site via HTTPS or change your browser settings.",
  AbortError = "Microphone access was aborted. Please retry and allow access when prompted.",
  OverconstrainedError = "Your device does not meet the required microphone settings. Please check if the correct device is selected.",
  InvalidStateError = "Microphone access cannot be processed at this time. Please refresh the page and try again.",
  TypeError = "There was an issue with microphone access. Please reload the page and try again.",
  UnknownError = "An unknown error occurred while accessing the microphone. Please try again."
}
